"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var street_address_format_hint_1 = require("./street_address_format_hint");
var bind_1 = require("../../../bind");
var controlled_input_1 = require("@reverbdotcom/commons/dist/components/controlled_input");
var country_selector_1 = require("../../discovery/country_selector");
var humps_1 = require("humps");
var AddressFields = /** @class */ (function (_super) {
    tslib_1.__extends(AddressFields, _super);
    function AddressFields(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            streetAddressForHint: '',
        };
        return _this;
    }
    AddressFields.prototype.decamelizedCountries = function () {
        return this.props.countriesForSelect.map(function (c) { return humps_1.decamelizeKeys(c); });
    };
    AddressFields.prototype.regionSelected = function (regionInput) {
        var region = regionInput ? regionInput.value : '';
        this.updateAddress({
            region: region,
        });
    };
    AddressFields.prototype.regionsForSelectedCountryCode = function () {
        var _this = this;
        var selectedCountry = this.props.countriesForSelect.find(function (country) {
            return country.countryCode === _this.props.address.countryCode;
        });
        if (selectedCountry && this.hasRegions(selectedCountry)) {
            return this.regionsForSelectWithBlank(selectedCountry.subregions.slice(0));
        }
        return [];
    };
    AddressFields.prototype.regionsForSelectWithBlank = function (regions) {
        return [{ code: '', name: '' }].concat(regions);
    };
    AddressFields.prototype.hasRegions = function (country) {
        return (country.subregions.length > 0);
    };
    AddressFields.prototype.noRegionsToSelect = function () {
        return (this.regionsForSelectedCountryCode().length === 0);
    };
    AddressFields.prototype.inputName = function (fieldName) {
        if (this.props.buildInputName) {
            return this.props.buildInputName(fieldName);
        }
        return fieldName;
    };
    AddressFields.prototype.regionsTextInput = function () {
        return (React.createElement(controlled_input_1.default, { inputType: "text", required: true, inputName: this.inputName('region'), fieldName: "region", inputValue: this.props.address.region, updateField: this.updateAddress }));
    };
    AddressFields.prototype.regionOptionsForSelect = function () {
        return (this.regionsForSelectedCountryCode().map(function (region) {
            return React.createElement("option", { key: region.code, value: region.code }, region.name);
        }));
    };
    AddressFields.prototype.regionsField = function () {
        var _this = this;
        if (this.noRegionsToSelect()) {
            return this.regionsTextInput();
        }
        return (React.createElement("div", { className: "styled-dropdown" },
            React.createElement("select", { autoComplete: "region", required: true, id: "region_field", name: this.inputName('region'), value: this.props.address.region, onChange: function (event) { return _this.regionSelected(event.target); } }, this.regionOptionsForSelect())));
    };
    AddressFields.prototype.updateAddress = function (attributes) {
        this.props.onUpdate(tslib_1.__assign(tslib_1.__assign({}, this.props.address), attributes));
    };
    AddressFields.prototype.onCountryChange = function (countryCode) {
        var addressAttributes = {
            countryCode: countryCode,
            region: '',
        };
        this.updateAddress(addressAttributes);
    };
    AddressFields.prototype.selectedCountryCode = function () {
        return (this.props.address.countryCode || '');
    };
    AddressFields.prototype.phoneInput = function () {
        if (!this.props.showPhone) {
            return null;
        }
        return (React.createElement("div", { className: "form-group mb-0" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", { htmlFor: this.inputName('phone') }, I18n.t('discovery.addresses.addressForm.phone'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement(controlled_input_1.default, { inputName: this.inputName('phone'), fieldName: "phone", placeholder: I18n.t('discovery.addresses.addressForm.placeholder.phone'), required: this.props.phoneInputRequired, autoComplete: "tel", inputType: "text", inputValue: this.props.address.phone, updateField: this.updateAddress }))));
    };
    AddressFields.prototype.onStreetAddressBlur = function (event) {
        this.setState({ streetAddressForHint: event.target.value });
    };
    AddressFields.prototype.nameInput = function () {
        return (React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" },
                React.createElement("label", { htmlFor: this.inputName('name') }, I18n.t('discovery.addresses.addressForm.name'))),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement(controlled_input_1.default, { inputName: this.inputName('name'), fieldName: "name", placeholder: I18n.t('discovery.addresses.addressForm.placeholder.name'), autoComplete: "name", required: true, inputType: "text", inputValue: this.props.address.name, updateField: this.updateAddress }))));
    };
    AddressFields.prototype.render = function () {
        return (React.createElement("div", null,
            this.nameInput(),
            React.createElement("div", { className: "form-group" },
                React.createElement("div", { className: "form-group__header" },
                    React.createElement("label", { htmlFor: this.inputName('street_address'), "data-address-title": true }, this.props.addressTitle)),
                React.createElement("div", { className: "form-group__fields" },
                    React.createElement(controlled_input_1.default, { inputType: "text", inputName: this.inputName('street_address'), fieldName: "streetAddress", placeholder: I18n.t('discovery.addresses.addressForm.placeholder.streetAddress'), inputValue: this.props.address.streetAddress, required: true, autoComplete: "street-address", onBlur: this.onStreetAddressBlur, updateField: this.updateAddress }),
                    React.createElement(controlled_input_1.default, { inputName: this.inputName('extended_address'), fieldName: "extendedAddress", placeholder: I18n.t('discovery.addresses.addressForm.placeholder.extendedAddress'), autoComplete: "street-address-2", inputType: "text", inputValue: this.props.address.extendedAddress, updateField: this.updateAddress, className: "mt-half" }),
                    React.createElement(street_address_format_hint_1.default, { streetAddress: this.state.streetAddressForHint }))),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: this.inputName('locality') }, I18n.t('discovery.addresses.addressForm.city'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement(controlled_input_1.default, { inputName: this.inputName('locality'), fieldName: "locality", placeholder: I18n.t('discovery.addresses.addressForm.placeholder.city'), required: true, autoComplete: "locality", inputType: "text", inputValue: this.props.address.locality, updateField: this.updateAddress })))),
                React.createElement("div", { className: "g-col-6 g-col-mobile-12" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: "region_field" }, I18n.t('discovery.addresses.addressForm.state'))),
                        React.createElement("div", { className: "form-group__fields" }, this.regionsField())))),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: this.inputName('postal_code') }, I18n.t('discovery.addresses.addressForm.zip_code'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement(controlled_input_1.default, { inputName: this.inputName('postal_code'), fieldName: "postalCode", placeholder: I18n.t('discovery.addresses.addressForm.placeholder.zip_code'), required: true, autoComplete: "postal-code", inputType: "text", inputValue: this.props.address.postalCode, updateField: this.updateAddress })))),
                React.createElement("div", { className: "g-col-6 g-col-mobile-12" },
                    React.createElement("div", { className: "form-group" },
                        React.createElement("div", { className: "form-group__header" },
                            React.createElement("label", { htmlFor: this.inputName('country_code') }, I18n.t('discovery.addresses.addressForm.country'))),
                        React.createElement("div", { className: "form-group__fields" },
                            React.createElement("div", { className: "styled-dropdown" },
                                React.createElement(country_selector_1.CountrySelector, { id: this.inputName('country_code'), inputName: this.inputName('country_code'), countries: this.decamelizedCountries(), onChange: this.onCountryChange, value: this.selectedCountryCode() })))))),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12" }, this.phoneInput()))));
    };
    AddressFields.defaultProps = {
        showPhone: true,
    };
    tslib_1.__decorate([
        bind_1.default
    ], AddressFields.prototype, "updateAddress", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressFields.prototype, "onCountryChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressFields.prototype, "onStreetAddressBlur", null);
    return AddressFields;
}(React.Component));
exports.default = AddressFields;
//# sourceMappingURL=address_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/addresses/address_fields.js
// module id = X3b2
// module chunks = 20 21 22